import { Link } from "react-router-dom";
import usePageMeta from "@/lib/usePageMeta";

// Shown for unknown routes during in-app navigation. Direct visits to unknown URLs get
// public/404.html with a real 404 status from the host (see public/_redirects).
export default function NotFound() {
  usePageMeta({ title: "Page not found", description: "This page doesn't exist on Unimora AI.", path: "/404" });
  return (
    <main className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="text-center max-w-md">
        <div className="text-micro font-semibold tracking-[0.05em] uppercase text-[var(--s400)] mb-3">404 · Page not found</div>
        <h1 className="text-h2 font-semibold text-[var(--s900)] mb-4">We couldn't find that page</h1>
        <p className="text-[var(--s500)] mb-6">The link may be old or mistyped.</p>
        <Link to="/" className="inline-block px-5 py-3 rounded-md bg-[#4F46E5] text-white font-semibold">
          Go to the homepage
        </Link>
      </div>
    </main>
  );
}
